import { render, staticRenderFns } from "./StandortDefault.vue?vue&type=template&id=2e024e87&scoped=true"
import script from "./StandortDefault.vue?vue&type=script&lang=js"
export * from "./StandortDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e024e87",
  null
  
)

export default component.exports